import { lazy } from "react";

const Reports = lazy(() => import("./Reports"));

const ReportsRoutes = [
  {
    path: "/Reports/reports",
    element: <Reports />,
  },
  
  
];

export default ReportsRoutes;
